export { default as InventoryDetail } from "./InventoryDetail";
